import { CallOverrides } from "ethers";
      /* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type CompetitionsContractFunctions1 =
  | []
  | [CompetitionsContractFunctions]
  | [CompetitionsContractFunctions, CompetitionsContractEvents];
export type SWEvent = {
  event: CompetitionsContractEventType;
  args: any;
}[];

export interface CompetitionsContractFunctions {
  addPartnerMemberToCompetition: (
    member: string,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<CompetitionsContractEvents>}>;
  createCheckpoint: (
    metadata: string,
    startCheckpointDate: number,
    endCheckpointDate: number,
    checkpointSkills: string,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<CompetitionsContractEvents>}>;
  endDate: (overrides?: CallOverrides) => Promise<number>;
  getParticipants: (overrides?: CallOverrides) => Promise<string[]>;
  getPartnerMembers: (overrides?: CallOverrides) => Promise<string[]>;
  isCompetitionSkill: (overrides?: CallOverrides) => Promise<boolean>;
  isOngoing: (overrides?: CallOverrides) => Promise<boolean>;
  isParticipant: (overrides?: CallOverrides) => Promise<boolean>;
  isPartner: (overrides?: CallOverrides) => Promise<boolean>;
  join: (overrides?: CallOverrides) => Promise<{wait: () => Promise<CompetitionsContractEvents>}>;
  metadataUri: (overrides?: CallOverrides) => Promise<string>;
  passCheckpoint: (
    participant: string,
    checkpointID: number,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<CompetitionsContractEvents>}>;
  role: (overrides?: CallOverrides) => Promise<number>;
  setWinners: (
    winners: string[],
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<CompetitionsContractEvents>}>;
  skills: (overrides?: CallOverrides) => Promise<number>;
  startDate: (overrides?: CallOverrides) => Promise<number>;
  winnersAddress: (overrides?: CallOverrides) => Promise<string>;
}
export interface CompetitionsContractEvents {
  events: SWEvent;
}

export enum CompetitionsContractEventType {
  CheckpointCreated = "CheckpointCreated",
  CheckpointPassed = "CheckpointPassed",
  ParticipantAdded = "ParticipantAdded",
  PartnerMemberAdded = "PartnerMemberAdded",
  WinnersSet = "WinnersSet"
}
